import { Calculator, Home, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getLinkClass = (path, isMobile = false) => {
    const isActive = location.pathname === path;
    const baseClass = isMobile 
      ? "block px-3 py-2 rounded-md text-base font-medium transition-colors"
      : "flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors";
      
    const activeClass = "text-blue-600 bg-blue-50";
    const inactiveClass = "text-gray-600 hover:text-blue-600 hover:bg-blue-50";
    
    return `${baseClass} ${isActive ? activeClass : inactiveClass}`;
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="bg-white shadow-sm relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 md:py-6">
          <Link to="/" className="flex items-center" onClick={closeMenu}>
            <Calculator className="h-8 w-8 text-blue-600 mr-3" />
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-gray-900">
                Math Games Hub
              </h1>
              <p className="text-xs md:text-sm text-gray-600">
                Interactive Learning Platform
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className={getLinkClass("/")}>
              <Home className="h-4 w-4 mr-1" />
              Home
            </Link>
            <Link to="/about" className={getLinkClass("/about")}>
              About
            </Link>
            <Link to="/contact" className={getLinkClass("/contact")}>
              Contact
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" aria-hidden="true" />
            ) : (
              <Menu className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-gray-100 animate-fade-in-down">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link
              to="/"
              className={getLinkClass("/", true)}
              onClick={closeMenu}
            >
              <div className="flex items-center">
                 <Home className="h-4 w-4 mr-2" />
                 Home
              </div>
            </Link>
            <Link
              to="/about"
              className={getLinkClass("/about", true)}
              onClick={closeMenu}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={getLinkClass("/contact", true)}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
